import { Timeline } from "antd";
import React, { memo } from "react";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  SignatureOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import Utils from "utils";

const MediTimeline = ({ data = [], customHeader }) => {
  const actionIcon = (action) => {
    switch (action) {
      case 1:
        // thêm
        return <PlusOutlined />;
      case 2:
        // sửa
        return <EditOutlined />;
      case 3:
        // xóa
        return <DeleteOutlined />;
      case 4:
        //ký
        return <SignatureOutlined />;

      default:
        return <SyncOutlined spin />;
    }
  };

  return (
    <>
      {customHeader}
      <Timeline>
        {data?.map((item) => (
          <Timeline.Item key={item.id} dot={actionIcon(item?.action)}>
            <div style={{ color: "#616161", fontSize: 12 }}>
              <b>
                (
                <span className="text-danger">
                  {item?.actionName || item.thaoTac}
                </span>
                ) {Utils.formatDate(item?.createdTime || item?.createdAt)} -{" "}
                <span className="text-success">{`${
                  item?.fullName || item?.nguoiSua
                } `}</span>{" "}
                {item?.objectType ? `- (${item?.objectType})` : ""}
              </b>
            </div>
            <div>
              <span
                style={{ fontWeight: "bold", fontSize: 14, color: "#181918" }}
              ></span>
              <span style={{ fontSize: 14, color: "#333537" }}>
                {item?.content || item?.noiDung}
              </span>
            </div>
          </Timeline.Item>
        ))}
      </Timeline>
    </>
  );
};

export default memo(MediTimeline);
